"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqSubtopicQuestionAnswerFromJSON = FaqSubtopicQuestionAnswerFromJSON;
exports.FaqSubtopicQuestionAnswerFromJSONTyped = FaqSubtopicQuestionAnswerFromJSONTyped;
exports.FaqSubtopicQuestionAnswerToJSON = FaqSubtopicQuestionAnswerToJSON;
exports.FaqSubtopicQuestionAnswerToJSONTyped = FaqSubtopicQuestionAnswerToJSONTyped;
function FaqSubtopicQuestionAnswerFromJSON(json) {
    return FaqSubtopicQuestionAnswerFromJSONTyped(json, false);
}
function FaqSubtopicQuestionAnswerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'light': json['light'],
        'active': json['active'],
        'sandokan': json['sandokan'],
        'rtlhu': json['rtlhu'],
        'linear': json['linear'],
        'common': json['common'],
    };
}
function FaqSubtopicQuestionAnswerToJSON(value) {
    return FaqSubtopicQuestionAnswerToJSONTyped(value, false);
}
function FaqSubtopicQuestionAnswerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'light': value.light,
        'active': value.active,
        'sandokan': value.sandokan,
        'rtlhu': value.rtlhu,
        'linear': value.linear,
        'common': value.common,
    };
}
